export default "__VITE_ASSET__CyiHd9$5__"